module.exports = __webpack_public_path__ + "static/media/TelegramIcon.310fbfe3.svg";